module.exports = __webpack_public_path__ + "static/media/circle3.45c90f59.svg";